import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';
import Icon from '@components/Icon';
import * as S from './styles';

interface Props {
  onConfirm: () => void;
  onClose?: () => void;
  title?: string;
  modalOpen?: boolean;
  children?: React.ReactNode,
  disabled?: boolean,
  isEdit?: boolean
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: 'background.paper',
  borderRadius: '14px'
};

const ModalComponent = ({ onClose, onConfirm, title, modalOpen, children, disabled, isEdit }: Props) => {

  return (
    <Modal
      onClose={onClose}
      open={modalOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <S.CloseButton onClick={onClose}>
          <Icon icon='close' size={14} />
        </S.CloseButton>
        
        <S.ModalTitle>{title}</S.ModalTitle>
        <S.Content>
          {children}
        </S.Content>
        <S.StyledActions>
          <Button variant='contained' color="secondary" size='large' sx={{ minWidth: 105 }} onClick={onClose}>Abbrechen</Button>
          <Button variant='contained' size='large' sx={{ minWidth: 105 }} disabled={disabled} onClick={onConfirm}>{isEdit ? 'Speichern' : 'Erstellen'}</Button>
        </S.StyledActions>
      </Box>
    </Modal>
  );
};

export default ModalComponent;
